/** Display helpers shared across pages. */

export const formatCurrency = (value, currency = "INR") =>
    new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency,
        maximumFractionDigits: 0,
    }).format(Number(value || 0));

export const formatDate = (value) =>
    value
        ? new Date(value).toLocaleDateString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
          })
        : "—";

export const formatDateTime = (value) =>
    value
        ? new Date(value).toLocaleString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
          })
        : "—";

/** Compact "3h ago" style timestamp for feeds and lists. */
export const formatRelativeTime = (value) => {
    if (!value) return "—";
    const diff = Date.now() - new Date(value).getTime();
    if (diff < 60_000) return "just now";
    const minutes = Math.floor(diff / 60_000);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days < 7) return `${days}d ago`;
    return formatDate(value);
};

/** MUI Chip colour per record status. */
export const statusColor = (status) =>
    ({
        new: "info",
        contacted: "warning",
        qualified: "success",
        unqualified: "error",
        converted: "success",
        open: "info",
        in_progress: "warning",
        pending: "warning",
        done: "success",
        won: "success",
        lost: "error",
        resolved: "success",
        closed: "default",
        cancelled: "default",
    })[status] || "default";
